<template>
  <div class="container">
    <img class="bugIcon" src="@/assets/images/404.png" />
    <p class="errorMessage">无效用户</p>
  </div>
</template>

<script>
export default {
  name: '404',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
}
.bugIcon {
  display: block;
  width: 120px;
  margin: 100px auto 20px;
}
.errorMessage {
  font-size: 14px;
  display: block;
  text-align: center;
}
</style>